export interface IDashDonorsPendingRemoteStatus {
    id: number
    fullName: string,
    donorId: number,
    isRemoteDonor: boolean,
    hasMicrositeRecipient: boolean,
    patientCenter: string,
    patientName: string,
    remoteStatus: number
    coordinatorId: number,
    comments: string,
    remoteStatusLastUpdatedDate: string,
    remoteStatusDate: string
}